import { WalletComponent } from './wallet/wallet.component';
import { JobContractCompleterComponent } from './job-contract-completer/job-contract.component';
import { JobReportContractComponent } from './job-report-contract/job-report-contract.component';
import { AddUserPostHiredDialogComponent } from './add-user-post-hired-dialog/add-user-post-hired-dialog.component';
import { KanbanSliderCvContractComponent } from './kanban-slider-cv-contract/kanban-slider-cv-contract.component';
import { PerformAnswerDialogComponent } from './perform-answer-dialog/perform-answer-dialog.component';
import { PollAnswerDialogComponent } from './poll-answer-dialog/poll-answer-dialog.component';
import { PollDialogComponent } from './poll-dialog/poll-dialog.component';
import { PollCompleterComponent } from './poll-completer/poll-completer.component';
import { PollSelectorDialogComponent } from './poll-selector-dialog/poll-selector-dialog.component';
import { PollComponent } from './poll/poll.component';
import { PerformComponent } from './perform/perform.component';
import { ViewPollComponent } from './view-poll/view-poll.component';
import { ViewJobContractComponent } from './view-job-contract/view-job-contract.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesRoutingModule } from './pages-routing.module';
import { PagesComponent } from './pages.component';
import { NgaModule } from '../theme/nga.module';
import {RatingModule} from "ngx-rating";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { Angular2FontawesomeModule } from 'angular2-fontawesome';
import { NgUploaderModule } from 'ngx-uploader';

import {
  ButtonModule,
  SplitButtonModule,
  GrowlModule,
  MessagesModule,
  InputTextModule,
  PasswordModule,
  SlideMenuModule,
  FileUploadModule,
  DataTableModule,
  SharedModule,
  InputTextareaModule,
  DropdownModule,
  ChipsModule,
  DialogModule,
  ConfirmDialogModule,
  ConfirmationService,
  InputMaskModule,
  GMapModule,
  CheckboxModule,
  MultiSelectModule,
  AutoCompleteModule,
  SelectButtonModule,
  InputSwitchModule,
  ChartModule,
  ToggleButtonModule
} from 'primeng/primeng';

import { NgxChartsModule } from '@swimlane/ngx-charts';

import { StoreModule } from '@ngrx/store';

import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { Ng2PaginationModule } from 'ng2-pagination';

import { AgmCoreModule } from '@agm/core';

import { MomentModule } from 'angular2-moment';

import { HttpModule, Http, RequestOptions } from '@angular/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslatePoHttpLoader } from '@biesbjerg/ngx-translate-po-http-loader';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { MdDialogModule } from '@angular/material';
import { MdTooltipModule } from '@angular/material';
import { MdSelectModule } from '@angular/material';
import { MdMenuModule } from '@angular/material';
import { MdProgressSpinnerModule } from '@angular/material';
import { MdSliderModule } from '@angular/material';
import { MdCheckboxModule } from '@angular/material';
import { MdExpansionModule } from '@angular/material';
import { MdProgressBarModule } from '@angular/material';
import { CalendarModule } from 'angular-calendar';

import { Ng2CompleterModule } from 'ng2-completer';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MyDatePickerModule } from 'mydatepicker';
import { NgbDatepickerModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { UiSwitchModule } from 'angular2-ui-switch/src';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { DndModule } from 'ng2-dnd';
import { DateTimePickerModule } from 'ng-pick-datetime';

import { DashboardComponent } from './dashboard/dashboard.component';
import { ViewLoginComponent } from './view-login/view-login.component';
import { ViewLoginPostComponent } from './view-login-post/view-login-post.component';
import { MenuComponent } from './menu/menu.component';

// components
import { ViewRequisition } from './view-requisition/view-requisition.component';
import { VenueCompleterComponent } from './venue-completer/venue-completer.component';
import { OfferCompleterComponent } from './offer-completer/offer-completer.component';
import { ItemCandidateRecommendedComponent } from './item-candidate-recommended/item-candidate-recommended.component';
import { RegisterComponentComponent } from './register-component/register-component.component';
import { RecoveryPasswordComponent } from './recovery-password/recovery-password.component';
import { DashboardMycreditsComponent } from './dashboard-mycredits/dashboard-mycredits.component';
import { LastMessageComponent } from './last-message/last-message.component';
import { ItemLastMessageComponent } from './item-last-message/item-last-message.component';
import { LastCandidatesComponent } from './last-candidates/last-candidates.component';
import { LastOffersComponent } from './last-offers/last-offers.component';
import { ItemCandidatesComponent } from './item-candidates/item-candidates.component';
import { CreateOfferComponent } from './create-offer/create-offer.component';
import { MessageComponent } from './message/message.component';
import { SearchCandidatesComponent } from './search-candidates/search-candidates.component';
import { SearchCandidatesMapComponent } from './search-candidates-map/search-candidates-map.component';
import { UsersComponent } from './users/users.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { MapComponent } from './map/map.component';
import { ListOfferComponent } from './list-offer/list-offer.component';
import { ListOfferContractComponent } from './list-offer-contract/list-offer-contract.component';
import { ListRequisitionComponent } from './list-requisition/list-requisition.component';
import { CvComponent } from './cv/cv.component';
import { JobReportComponent } from './job-report/job-report.component';
import { CvMapComponent } from './cv-map/cv-map.component';
import { SendMessageComponent } from './send-message/send-message.component';
import { SliderMapCvComponent } from './slider-map-cv/slider-map-cv.component';
import { SentMessageDialogComponent } from './sent-message-dialog/sent-message-dialog.component';
import { ListCandidatesComponent } from './list-candidates/list-candidates.component';
import { ListCandidatesMapComponent } from './list-candidates-map/list-candidates-map.component';
import { HistoryCreditsDialogComponent } from './history-credits-dialog/history-credits-dialog.component';
import { HvRecommendedComponent } from './hv-recommended/hv-recommended.component';
import { SocialmediaDialogComponent } from './socialmedia-dialog/socialmedia-dialog.component';
import { ConfirmDeleteDialogComponent } from './confirm-delete-dialog/confirm-delete-dialog.component';
import { PromoteJobsOfferDialogComponent } from './promote-jobs-offer-dialog/promote-jobs-offer-dialog.component';
import { ViewCvComponent } from './view-cv/view-cv.component';
import { SliderCvComponent } from './slider-cv/slider-cv.component';
import { KanbanSliderCvComponent } from './kanban-slider-cv/kanban-slider-cv.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { MessageBoxDialog } from './message-box/message-box.component';
import { MessageBoxKanbanDialog } from './message-box-kanban/message-box-kanban.component';
import { MessageBoxInviteDialog } from './message-box-invite/message-box-invite.component';
import { ViewEventComponent } from './view-event/view-event.component';
import { EventDialogComponent } from './event-dialog/event-dialog.component';
import { EventMassiveDialogComponent } from './event-massive-dialog/event-massive-dialog.component';
import { ReminderDialogComponent } from './reminder-dialog/reminder-dialog.component';
import { ViewNotificationComponent } from './view-notification/view-notification.component';
import { ViewTransactionComponent } from './view-transaction/view-transaction.component';
import { TransactionDetailDialogComponent } from './transaction-detail-dialog/transaction-detail-dialog.component';
import { FormCompetenceSelectorDialogComponent } from './form-competence-selector-dialog/form-competence-selector-dialog.component';
import { VideoDialogComponent } from './video-dialog/video-dialog.component';
import { ViewFormComponent } from './view-form/view-form.component';
import { ApplyStatusComponent } from './apply-status/apply-status.component';
import { ViewVenueComponent } from './view-venue/view-venue.component';
import { FormComponent } from './form/form.component';
import { FilesComponent } from './files/files.component';
import { InviteComponent } from './invite/invite.component';
import { JobSelectorDialogComponent } from './job-selector-dialog/job-selector-dialog.component';
import { ViewInviteComponent } from './view-invite/view-invite.component';
import { ViewJobComponent } from './view-job/view-job.component';
import { ItemCandidateInviteComponent } from './item-candidate-invite/item-candidate-invite.component';
import { ItemInviteUserDetailDialogComponent } from './item-invite-user-detail-dialog/item-invite-user-detail-dialog.component';
import { ItemCandidateComponent } from './item-candidate/item-candidate.component';
import { ItemCandidateMapComponent } from './item-candidate-map/item-candidate-map.component';
import { TypeEventComponent } from './type-event/type-event.component';
import { PaymentDialogComponent } from './payment-dialog/payment-dialog.component';
import { EditOfferVacancyDialogComponent } from './edit-offer-vacancy-dialog/edit-offer-vacancy-dialog.component';
import { AnnotationDialogComponent } from './annotation-dialog/annotation-dialog.component';
import { MessageDialogComponent } from './message-dialog/message-dialog.component';
import { ApplyDialogComponent } from './apply-dialog/apply-dialog.component';
import { ReportsComponent } from './reports/reports.component';
import { ReportOfferComponent } from './reports/report-offer/report-offer.component';
import { KanbanComponent } from './kanban/kanban.component';
import { KanbanTimelineComponent } from './kanban-timeline/kanban-timeline.component';
import { CheckDocsComponent } from './check-docs/check-docs.component';
import { CheckDocListComponent } from './check-doc-list/check-doc-list.component';
import { MessageBoxCheckDialog } from './message-box-check/message-box-check.component';
import { CalendarComponent } from './view-event/calendar.component';
import { BlockchainComponent } from './blockchain/blockchain.component';
import { DateTimePickerComponent } from './view-event/date-time-picker.component';
import { TourNgxBootstrapModule } from 'ngx-tour-ngx-bootstrap';
// import { TourNgxPopperModule } from 'ngx-tour-ngx-popper';
// import { NgxPopperModule } from 'ngx-popper';


import { OnlyNumber } from './directives/only-number.directive';
import { HighlightPipe } from './pipes/highlight.pipe';
import { PollListDialogComponent } from './poll-list-dialog/poll-list-dialog.component';
import { KanbanContractComponent } from './kanban-contract/kanban-contract.component';

export function createTranslateLoader(http: Http) {
  return new TranslatePoHttpLoader(http, '/assets/i18n/', '.po');
}

@NgModule({
  imports: [
    CommonModule,
    PagesRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    ButtonModule,
    SplitButtonModule,
    GrowlModule,
    MessagesModule,
    InputTextModule,
    PasswordModule,
    SlideMenuModule,
    FileUploadModule,
    DataTableModule,
    SharedModule,
    InputTextareaModule,
    DropdownModule,
    ChipsModule,
    DialogModule,
    RatingModule,
    ConfirmDialogModule,
    InputMaskModule,
    GMapModule,
    CheckboxModule,
    //NgxPopperModule,
    MultiSelectModule,
    AutoCompleteModule,
    SelectButtonModule,
    InputSwitchModule,
    ChartModule,
    CalendarModule.forRoot(),
    ToggleButtonModule,
    Angular2PromiseButtonModule.forRoot({
        spinnerTpl: '<i class="fa fa-circle-o-notch fa-spin fa-fw btn-load"></i>',
        disableBtn: true,
        btnLoadingClass: 'is-loading',
        handleCurrentBtnOnly: false,
    }),
    NgaModule,
    HttpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [Http]
      }
    }),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD041mK0SKDmCT9s6gaZ3XAq-psuHgA_Ec',
      libraries: ['places']
    }),
    MomentModule,
    StoreModule.forRoot({
    }),
    InfiniteScrollModule,
    NgxChartsModule,
    Angular2FontawesomeModule,
    NgUploaderModule,
    MdDialogModule,
    MdTooltipModule,
    MdSelectModule,
    MdCheckboxModule,
    MdExpansionModule,
    MdMenuModule,
    MdProgressSpinnerModule,
    MdSliderModule,
    MdProgressBarModule,
    Ng2CompleterModule,
    NgbModule.forRoot(),
    MyDatePickerModule,
    NgbDatepickerModule.forRoot(),
    NgbTimepickerModule.forRoot(),
    Ng2PaginationModule,
    UiSwitchModule,
    MultiselectDropdownModule,
    DndModule.forRoot(),
    DateTimePickerModule,
    CalendarModule,
    TourNgxBootstrapModule.forRoot(),
    //TourNgxPopperModule.forRoot(),
  ],
  declarations: [
    PagesComponent,
    DashboardComponent,
    ViewLoginComponent,
    ViewLoginPostComponent,
    MenuComponent,
    VenueCompleterComponent,
    OfferCompleterComponent,
    PollCompleterComponent,
    JobContractCompleterComponent,
    RegisterComponentComponent,
    RecoveryPasswordComponent,
    DashboardComponent,
    DashboardMycreditsComponent,
    LastMessageComponent,
    ListOfferContractComponent,
    ViewJobContractComponent,
    ItemLastMessageComponent,
    LastCandidatesComponent,
    ViewPollComponent,
    LastOffersComponent,
    CheckDocsComponent,
    CheckDocListComponent,
    ItemCandidatesComponent,
    BlockchainComponent,
    WalletComponent,
    CreateOfferComponent,
    MenuComponent,
    MessageComponent,
    ViewFormComponent,
    ViewRequisition,
    ViewVenueComponent,
    SliderMapCvComponent,
    CvMapComponent,
    FormComponent,
    FilesComponent,
    SearchCandidatesComponent,
    SearchCandidatesMapComponent,
    UsersComponent,
    ConfigurationComponent,
    MapComponent,
    ListOfferComponent,
    ListRequisitionComponent,
    CvComponent,
    JobReportComponent,
    JobReportContractComponent,
    SendMessageComponent,
    SentMessageDialogComponent,
    ListCandidatesComponent,
    ListCandidatesMapComponent,
    HistoryCreditsDialogComponent,
    HvRecommendedComponent,
    ItemCandidateRecommendedComponent,
    SocialmediaDialogComponent,
    ConfirmDeleteDialogComponent,
    PollSelectorDialogComponent,
    PollListDialogComponent,
    PollDialogComponent,
    PollAnswerDialogComponent,
    PerformAnswerDialogComponent,
    PromoteJobsOfferDialogComponent,
    ViewCvComponent,
    SliderCvComponent,
    KanbanSliderCvComponent,
    KanbanSliderCvContractComponent,
    PageNotFoundComponent,
    MessageBoxDialog,
    MessageBoxKanbanDialog,
    MessageBoxCheckDialog,
    InviteComponent,
    JobSelectorDialogComponent,
    ApplyDialogComponent,
    ViewInviteComponent,
    ViewJobComponent,
    MessageBoxInviteDialog,
    ItemCandidateInviteComponent,
    ItemInviteUserDetailDialogComponent,
    ItemCandidateComponent,
    ItemCandidateMapComponent,
    AnnotationDialogComponent,
    MessageDialogComponent,
    ApplyStatusComponent,
    KanbanComponent,
    KanbanContractComponent,
    ReportsComponent,
    ReportOfferComponent,
    ViewEventComponent,
    CalendarComponent,
    TypeEventComponent,
    EventDialogComponent,
    ReminderDialogComponent,
    PollComponent,
    PerformComponent,
    ViewNotificationComponent,
    PaymentDialogComponent,
    ViewTransactionComponent,
    EditOfferVacancyDialogComponent,
    AddUserPostHiredDialogComponent,
    TransactionDetailDialogComponent,
    KanbanTimelineComponent,
    FormCompetenceSelectorDialogComponent,
    EventMassiveDialogComponent,
    VideoDialogComponent,
    OnlyNumber,
    HighlightPipe,
    DateTimePickerComponent,
  ],
  entryComponents: [
    UsersComponent,
    SendMessageComponent,
    SentMessageDialogComponent,
    HistoryCreditsDialogComponent,
    SocialmediaDialogComponent,
    ConfirmDeleteDialogComponent,
    PromoteJobsOfferDialogComponent,
    SliderMapCvComponent,
    JobReportComponent,
    JobReportContractComponent,
    PollListDialogComponent,
    PollAnswerDialogComponent,
    PerformAnswerDialogComponent,
    PollDialogComponent,
    CvMapComponent,
    SliderCvComponent,
    KanbanSliderCvComponent,
    KanbanSliderCvContractComponent,
    ViewCvComponent,
    MessageBoxDialog,
    MessageBoxKanbanDialog,
    MessageBoxCheckDialog,
    FormComponent,
    FilesComponent,
    InviteComponent,
    HvRecommendedComponent,
    ItemCandidateRecommendedComponent,
    JobSelectorDialogComponent,
    PollSelectorDialogComponent,
    MessageBoxInviteDialog,
    AnnotationDialogComponent,
    ApplyDialogComponent,
    ApplyStatusComponent,
    MessageDialogComponent,
    CalendarComponent,
    PollComponent,
    PerformComponent,
    TypeEventComponent,
    EventDialogComponent,
    ReminderDialogComponent,
    ViewNotificationComponent,
    ItemInviteUserDetailDialogComponent,
    PaymentDialogComponent,
    ViewTransactionComponent,
    ViewRequisition,
    EditOfferVacancyDialogComponent,
    AddUserPostHiredDialogComponent,
    TransactionDetailDialogComponent,
    FormCompetenceSelectorDialogComponent,
    EventMassiveDialogComponent,
    VideoDialogComponent
  ]
})
export class PagesModule { }



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/pages.module.ts